<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail" :colon="false">
        <a-row>
          <!-- <a-col :span="8">
            <a-form-item label="对应meteruserinfo 的主键id">
              <a-input v-decorator="['userKeyId']" placeholder="请输入对应meteruserinfo 的主键id" style="width:96%"></a-input>
            </a-form-item>
          </a-col> -->
          <a-col :span="8">
            <a-form-item :label="$t('用户编号')">
              <a-input v-decorator="['meterUserId']" :placeholder="$t('请输入用户编号')" style="width:96%"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('表编号')">
              <a-input v-decorator="['meterId']" :placeholder="$t('请输入表编号')" style="width:96%"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('账户实时表变动前金额')">
              <a-input-number v-decorator="['userPreAccountNum']" :placeholder="$t('请输入账户实时表变动前金额 单位分')" style="width:96%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('账户变动后剩余金额')">
              <a-input-number v-decorator="['userNowAccountNum']" :placeholder="$t('请输入账户变动后剩余金额 单位分')" style="width:96%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('用户账户变动前用户累积量')">
              <a-input-number v-decorator="['userPreWaterNum']" :placeholder="$t('请输入用户账户变动前用户累积量')" style="width:96%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('用户变动后用水累计量')">
              <a-input-number v-decorator="['userNowWaterNum']" :placeholder="$t('请输入用户变动后用水累计量')" style="width:96%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('用户账户变动金额')">
              <a-input-number v-decorator="['userChangeAccountNum']" :placeholder="$t('请输入用户账户变动金额')" style="width:96%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('用户金额变动类型')">
              <a-input-number v-decorator="['userAccountChangeType']" :placeholder="$t('请输入用户金额变动类型 1开户 2充值 3计费 4补水 5退水 6换表')" style="width:96%"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('用户变动备注')">
              <a-input v-decorator="['changeRemark']" :placeholder="$t('请输入用户变动备注')" style="width:98.8%"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('用户变动备注备用1')">
              <a-input v-decorator="['changeRemakr1']" :placeholder="$t('请输入用户变动备注备用1')" style="width:98.8%"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('备注')">
              <a-textarea v-decorator="['remark']" :placeholder="$t('请输入备注信息')" rows="4" style="width:98.8%" />
            </a-form-item>
          </a-col>
          <!-- <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col> -->
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'

  export default {
    name: 'MeterUserAccountChangeRecordForm',
    components: {
      JFormContainer,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/meter/meterUserAccountChangeRecord/add",
          edit: "/jeecg-charge/meter/meterUserAccountChangeRecord/edit",
          queryById: "/jeecg-charge/meter/meterUserAccountChangeRecord/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'userKeyId','meterUserId','meterId','userPreAccountNum','userNowAccountNum','userPreWaterNum','userNowWaterNum','userChangeAccountNum','userAccountChangeType','changeRemark','changeRemakr1','createTime','createBy','updateTime','updateBy','remark','sysOrgCode'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit(res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'userKeyId','meterUserId','meterId','userPreAccountNum','userNowAccountNum','userPreWaterNum','userNowWaterNum','userChangeAccountNum','userAccountChangeType','changeRemark','changeRemakr1','createTime','createBy','updateTime','updateBy','remark','sysOrgCode'))
      },
    }
  }
</script>
